import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { fetchThread } from '../actions/messages';

const MessageCentreRoute = loadable(
  () => import(/* webpackChunkName: "thread" */ '../containers/ThreadView'),
  { fallback: Loading }
);

MessageCentreRoute.needs = (props, { dispatch }) => {
  MessageCentreRoute.preload();
  return dispatch(fetchThread(props.params.group));
};

export default MessageCentreRoute;
